import {
  bindEvents,
  closeSecondaryMenuMobile,
  fadeInPrimaryMenuItems
} from "./chunk.OOINLVPA.js";
import {
  isMobile
} from "./chunk.YDQDJZUC.js";
import {
  Rt
} from "./chunk.LTAMHVKK.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.ABOYTYJO.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Animatable
} from "./chunk.VRR2P3PQ.js";
import {
  JBCookie,
  debounce,
  getEventElement
} from "./chunk.WXNWU2SV.js";
import {
  D,
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  n,
  r as r2
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/jb-menu/jb-menu.scss?inline
var jb_menu_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
.mobile-menu .secondary-wrapper .submenu-header .tag {
  font-family: var(--theme-font-bold-family, VerlagSSm, Tahoma, sans-serif);
  font-weight: var(--theme-font-bold-weight, 700);
}

.mobile-menu .secondary-wrapper .submenu-header .title {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  background-color: #141e55;
  display: block;
  height: 100%;
  height: calc(100vh - 60px);
  transform-origin: top center;
  width: 100%;
}
@media (min-width: 600px) {
  :host {
    height: calc(100vh - 90px);
  }
}
@media (min-width: 1281px) {
  :host {
    height: calc(100vh - 100px);
  }
}

.desktop-menu {
  --menu-padding-top: 70px;
  height: 100%;
  overflow: hidden;
  padding-top: var(--menu-padding-top);
  transition: transform 0.5s ease-out, padding-top 0.2s linear;
  width: 100%;
  z-index: 201;
}
.desktop-menu div {
  display: flex;
  height: 100%;
  padding-left: 6.955vw;
}
@media (min-width: 1437px) and (hover: hover) {
  .desktop-menu div {
    padding-left: calc((100vw - var(--row-max-width, 1436px)) / 2);
  }
}
.desktop-menu div .primary-wrapper,
.desktop-menu div .secondary-wrapper {
  box-sizing: border-box;
  flex-basis: 33.3333333333%;
  max-width: 33.3333333333%;
  padding: 0 20px;
  width: 33.3333333333%;
  margin-left: 16.6666666667%;
}
.desktop-menu div .primary-wrapper {
  flex-basis: calc(86.09vw * 0.3333);
  margin-left: calc(86.09vw * 0.1667);
  max-width: calc(86.09vw * 0.3333);
  overflow-y: auto;
  width: calc(86.09vw * 0.3333);
}
.desktop-menu div .primary-wrapper jb-menu-item,
.desktop-menu div .primary-wrapper jb-service-navigation {
  opacity: 0;
}
.desktop-menu div .primary-wrapper::-webkit-scrollbar {
  background-color: #f1f2f2;
  width: 5px;
}
.desktop-menu div .primary-wrapper::-webkit-scrollbar-track {
  background-clip: content-box;
  background-color: #141e55;
}
.desktop-menu div .primary-wrapper::-webkit-scrollbar-thumb {
  background-color: #f1f2f2;
  border-radius: 4px;
  width: 180px;
}
@media (min-width: 1437px) and (hover: hover) {
  .desktop-menu div .primary-wrapper {
    flex-basis: calc(var(--row-max-width, 1436px) * 0.3333);
    margin-left: calc(var(--row-max-width, 1436px) * 0.1667);
    max-width: calc(var(--row-max-width, 1436px) * 0.3333);
    width: calc(var(--row-max-width, 1436px) * 0.3333);
  }
}
.desktop-menu div .primary-wrapper.hidden {
  opacity: 0;
  z-index: -1;
}
.desktop-menu div .primary-wrapper jb-service-navigation {
  display: none;
}
.desktop-menu div .primary-wrapper .primary {
  flex-basis: 100%;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(1) {
  transition: opacity 0.5s ease-in-out 0s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(2) {
  transition: opacity 0.5s ease-in-out 0.2s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(3) {
  transition: opacity 0.5s ease-in-out 0.4s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(4) {
  transition: opacity 0.5s ease-in-out 0.6s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(5) {
  transition: opacity 0.5s ease-in-out 0.8s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(6) {
  transition: opacity 0.5s ease-in-out 1s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(7) {
  transition: opacity 0.5s ease-in-out 1.2s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(8) {
  transition: opacity 0.5s ease-in-out 1.4s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(9) {
  transition: opacity 0.5s ease-in-out 1.6s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(10) {
  transition: opacity 0.5s ease-in-out 1.8s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(11) {
  transition: opacity 0.5s ease-in-out 2s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(12) {
  transition: opacity 0.5s ease-in-out 2.2s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(13) {
  transition: opacity 0.5s ease-in-out 2.4s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(14) {
  transition: opacity 0.5s ease-in-out 2.6s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(15) {
  transition: opacity 0.5s ease-in-out 2.8s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(16) {
  transition: opacity 0.5s ease-in-out 3s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(17) {
  transition: opacity 0.5s ease-in-out 3.2s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(18) {
  transition: opacity 0.5s ease-in-out 3.4s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(19) {
  transition: opacity 0.5s ease-in-out 3.6s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(20) {
  transition: opacity 0.5s ease-in-out 3.8s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden {
  opacity: 0;
  z-index: -1;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(1) {
  transition: opacity 0.5s ease-in-out 1s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(2) {
  transition: opacity 0.5s ease-in-out 0.8s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(3) {
  transition: opacity 0.5s ease-in-out 0.6s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(4) {
  transition: opacity 0.5s ease-in-out 0.4s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(5) {
  transition: opacity 0.5s ease-in-out 0.2s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(6) {
  transition: opacity 0.5s ease-in-out 0s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(7) {
  transition: opacity 0.5s ease-in-out -0.2s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(8) {
  transition: opacity 0.5s ease-in-out -0.4s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(9) {
  transition: opacity 0.5s ease-in-out -0.6s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(10) {
  transition: opacity 0.5s ease-in-out -0.8s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(11) {
  transition: opacity 0.5s ease-in-out -1s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(12) {
  transition: opacity 0.5s ease-in-out -1.2s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(13) {
  transition: opacity 0.5s ease-in-out -1.4s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(14) {
  transition: opacity 0.5s ease-in-out -1.6s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(15) {
  transition: opacity 0.5s ease-in-out -1.8s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(16) {
  transition: opacity 0.5s ease-in-out -2s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(17) {
  transition: opacity 0.5s ease-in-out -2.2s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(18) {
  transition: opacity 0.5s ease-in-out -2.4s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(19) {
  transition: opacity 0.5s ease-in-out -2.6s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(20) {
  transition: opacity 0.5s ease-in-out -2.8s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(1) {
  --padding-top: 10px;
}
@media (min-width: 1281px) {
  .desktop-menu div .primary-wrapper .primary jb-menu-item {
    --padding-top: 25px;
  }
}
.desktop-menu div .secondary-wrapper {
  margin-left: 0%;
  flex-grow: 1;
  max-width: none;
  overflow: hidden auto;
  -webkit-overflow-scrolling: touch;
  padding-right: 0;
  position: relative;
}
.desktop-menu div .secondary-wrapper::-webkit-scrollbar {
  background-color: #f1f2f2;
  width: 5px;
}
.desktop-menu div .secondary-wrapper::-webkit-scrollbar-track {
  background-clip: content-box;
  background-color: #141e55;
}
.desktop-menu div .secondary-wrapper::-webkit-scrollbar-thumb {
  background-color: #f1f2f2;
  border-radius: 4px;
  width: 180px;
}
.desktop-menu div .secondary-wrapper .submenu-header.hidden {
  display: none;
}
.desktop-menu div .secondary-wrapper .secondary {
  transition: opacity 0.4s;
  z-index: -1;
}
.desktop-menu div .secondary-wrapper .secondary .desktop-menu__item.hidden {
  transition: opacity 0.5s ease-in-out, height 0s 0.5s;
}
.desktop-menu div .secondary-wrapper .secondary .desktop-menu__item:last-child {
  padding-bottom: 150px;
}
.desktop-menu a {
  display: inline-block;
}
.desktop-menu jb-secondary-menu-list {
  opacity: 0;
  transition: opacity 0.4s ease-in-out;
}
.desktop-menu jb-secondary-menu-list.active {
  opacity: 1;
  z-index: 99;
}

.mobile-menu {
  overflow: hidden;
  padding-bottom: 112px;
  padding-top: 30px;
  transition: transform 0.5s ease-out, padding-top 0.2s linear;
  width: 100%;
  z-index: 201;
}
@media (min-width: 600px) {
  .mobile-menu {
    padding-top: 50px;
  }
}
@media (min-width: 960px) {
  .mobile-menu {
    padding-top: 70px;
  }
}
.mobile-menu .wrapper {
  display: flex;
  padding-left: 0;
}
.mobile-menu jb-service-navigation {
  display: block;
  margin-top: 40px;
  opacity: 1;
  text-align: center;
  transition: opacity 0.35s ease-in-out 0.1s;
}
.mobile-menu jb-service-navigation.hidden {
  opacity: 0;
}
.mobile-menu .primary-wrapper {
  position: relative;
}
.mobile-menu .primary-wrapper jb-menu-item,
.mobile-menu .primary-wrapper jb-service-navigation {
  opacity: 0;
}
.mobile-menu .primary-wrapper.hidden {
  opacity: 0;
  z-index: -1;
}
.mobile-menu .primary-wrapper jb-menu-item {
  --padding-bottom: 16px;
  --padding-top: 25px;
}
.mobile-menu .primary-wrapper jb-menu-item:nth-child(1) {
  --padding-top: 0;
}
@media (min-width: 600px) {
  .mobile-menu .primary-wrapper jb-menu-item {
    --padding-top: 21px;
  }
}
@media (hover: none) and (min-width: 600px) {
  .mobile-menu .primary-wrapper jb-menu-item {
    --padding-top: 24px;
  }
}
.mobile-menu .primary-wrapper jb-menu-item.hidden {
  opacity: 0;
  z-index: -1;
}
.mobile-menu .primary-wrapper .primary {
  box-sizing: border-box;
  display: flex;
  flex: 0 1 auto;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: auto;
  margin-right: auto;
  width: calc(100% - 2 * var(--row-small-margin, 6.68%));
  display: block;
  margin-left: var(--row-small-margin, 6.68%);
  margin-right: auto;
}
@media (min-width: 600px) and (max-width: 959px) {
  .mobile-menu .primary-wrapper .primary {
    width: calc(100% - 2 * 8.35%);
  }
}
@media (min-width: 1437px) {
  .mobile-menu .primary-wrapper .primary {
    max-width: var(--row-max-width, 1436px);
  }
  .mobile-menu .primary-wrapper .primary:not(.filtered-list) {
    width: 100%;
  }
}
@media only screen and (min-width: 960px) and (max-width: 1436px) {
  .mobile-menu .primary-wrapper .primary {
    margin: 0 6.955%;
    max-width: calc(100% - 6.955% - 6.955%);
  }
}
@media (min-width: 600px) {
  .mobile-menu .primary-wrapper .primary {
    margin-left: 30vw;
    width: 40vw;
  }
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(1) {
  transition: opacity 0.5s ease-in-out 0s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(2) {
  transition: opacity 0.5s ease-in-out 0.2s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(3) {
  transition: opacity 0.5s ease-in-out 0.4s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(4) {
  transition: opacity 0.5s ease-in-out 0.6s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(5) {
  transition: opacity 0.5s ease-in-out 0.8s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(6) {
  transition: opacity 0.5s ease-in-out 1s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(7) {
  transition: opacity 0.5s ease-in-out 1.2s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(8) {
  transition: opacity 0.5s ease-in-out 1.4s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(9) {
  transition: opacity 0.5s ease-in-out 1.6s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(10) {
  transition: opacity 0.5s ease-in-out 1.8s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(11) {
  transition: opacity 0.5s ease-in-out 2s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(12) {
  transition: opacity 0.5s ease-in-out 2.2s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(13) {
  transition: opacity 0.5s ease-in-out 2.4s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(14) {
  transition: opacity 0.5s ease-in-out 2.6s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(15) {
  transition: opacity 0.5s ease-in-out 2.8s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(16) {
  transition: opacity 0.5s ease-in-out 3s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(17) {
  transition: opacity 0.5s ease-in-out 3.2s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(18) {
  transition: opacity 0.5s ease-in-out 3.4s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(19) {
  transition: opacity 0.5s ease-in-out 3.6s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(20) {
  transition: opacity 0.5s ease-in-out 3.8s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(1) {
  transition: opacity 0.5s ease-in-out 1s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(2) {
  transition: opacity 0.5s ease-in-out 0.8s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(3) {
  transition: opacity 0.5s ease-in-out 0.6s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(4) {
  transition: opacity 0.5s ease-in-out 0.4s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(5) {
  transition: opacity 0.5s ease-in-out 0.2s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(6) {
  transition: opacity 0.5s ease-in-out 0s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(7) {
  transition: opacity 0.5s ease-in-out -0.2s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(8) {
  transition: opacity 0.5s ease-in-out -0.4s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(9) {
  transition: opacity 0.5s ease-in-out -0.6s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(10) {
  transition: opacity 0.5s ease-in-out -0.8s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(11) {
  transition: opacity 0.5s ease-in-out -1s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(12) {
  transition: opacity 0.5s ease-in-out -1.2s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(13) {
  transition: opacity 0.5s ease-in-out -1.4s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(14) {
  transition: opacity 0.5s ease-in-out -1.6s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(15) {
  transition: opacity 0.5s ease-in-out -1.8s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(16) {
  transition: opacity 0.5s ease-in-out -2s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(17) {
  transition: opacity 0.5s ease-in-out -2.2s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(18) {
  transition: opacity 0.5s ease-in-out -2.4s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(19) {
  transition: opacity 0.5s ease-in-out -2.6s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(20) {
  transition: opacity 0.5s ease-in-out -2.8s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(1) {
  transition: opacity 0.5s ease-in-out 0s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(2) {
  transition: opacity 0.5s ease-in-out 0.2s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(3) {
  transition: opacity 0.5s ease-in-out 0.4s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(4) {
  transition: opacity 0.5s ease-in-out 0.6s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(5) {
  transition: opacity 0.5s ease-in-out 0.8s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(6) {
  transition: opacity 0.5s ease-in-out 1s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(7) {
  transition: opacity 0.5s ease-in-out 1.2s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(8) {
  transition: opacity 0.5s ease-in-out 1.4s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(9) {
  transition: opacity 0.5s ease-in-out 1.6s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(10) {
  transition: opacity 0.5s ease-in-out 1.8s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(11) {
  transition: opacity 0.5s ease-in-out 2s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(12) {
  transition: opacity 0.5s ease-in-out 2.2s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(13) {
  transition: opacity 0.5s ease-in-out 2.4s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(14) {
  transition: opacity 0.5s ease-in-out 2.6s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(15) {
  transition: opacity 0.5s ease-in-out 2.8s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(16) {
  transition: opacity 0.5s ease-in-out 3s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(17) {
  transition: opacity 0.5s ease-in-out 3.2s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(18) {
  transition: opacity 0.5s ease-in-out 3.4s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(19) {
  transition: opacity 0.5s ease-in-out 3.6s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(20) {
  transition: opacity 0.5s ease-in-out 3.8s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(21) {
  transition: opacity 0.5s ease-in-out 4s;
}
.mobile-menu .primary-wrapper,
.mobile-menu .secondary-wrapper {
  overflow: hidden auto;
  -webkit-overflow-scrolling: touch;
  width: 100%;
}
.mobile-menu .primary-wrapper::-webkit-scrollbar,
.mobile-menu .secondary-wrapper::-webkit-scrollbar {
  background-color: #f1f2f2;
  width: 5px;
}
.mobile-menu .primary-wrapper::-webkit-scrollbar-track,
.mobile-menu .secondary-wrapper::-webkit-scrollbar-track {
  background-clip: content-box;
  background-color: #141e55;
}
.mobile-menu .primary-wrapper::-webkit-scrollbar-thumb,
.mobile-menu .secondary-wrapper::-webkit-scrollbar-thumb {
  background-color: #f1f2f2;
  border-radius: 4px;
  width: 180px;
}
.mobile-menu .secondary-wrapper {
  left: 0;
  opacity: 0;
  padding-top: 16px;
  pointer-events: none;
  position: absolute;
  right: 0;
  z-index: -1;
}
.mobile-menu .secondary-wrapper jb-button-back {
  cursor: pointer;
  display: block;
  margin-bottom: 20px;
  opacity: 0;
  transform: translateX(20px);
  transition: opacity 0.35s ease-in, transform 0.35s ease-in-out;
  z-index: 10;
}
.mobile-menu .secondary-wrapper.active {
  height: calc(100vh - 90px);
  opacity: 1;
  pointer-events: all;
  z-index: 1;
}
@media (min-width: 600px) {
  .mobile-menu .secondary-wrapper.active {
    height: calc(100vh - 140px);
  }
}
@media (min-width: 960px) {
  .mobile-menu .secondary-wrapper.active {
    height: calc(100vh - 160px);
  }
}
.mobile-menu .secondary-wrapper.active jb-button-back {
  opacity: 1;
  transform: translateX(0);
}
.mobile-menu .secondary-wrapper.fade-out {
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}
.mobile-menu .secondary-wrapper .submenu-header {
  box-sizing: border-box;
  display: flex;
  flex: 0 1 auto;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: auto;
  margin-right: auto;
  width: calc(100% - 2 * var(--row-small-margin, 6.68%));
  display: block;
  margin-bottom: 26px;
}
@media (min-width: 600px) and (max-width: 959px) {
  .mobile-menu .secondary-wrapper .submenu-header {
    width: calc(100% - 2 * 8.35%);
  }
}
@media (min-width: 1437px) {
  .mobile-menu .secondary-wrapper .submenu-header {
    max-width: var(--row-max-width, 1436px);
  }
  .mobile-menu .secondary-wrapper .submenu-header:not(.filtered-list) {
    width: 100%;
  }
}
@media only screen and (min-width: 960px) and (max-width: 1436px) {
  .mobile-menu .secondary-wrapper .submenu-header {
    margin: 0 6.955%;
    max-width: calc(100% - 6.955% - 6.955%);
  }
}
@media (min-width: 600px) {
  .mobile-menu .secondary-wrapper .submenu-header {
    margin-bottom: 40px;
    margin-left: 30vw;
    width: 40vw;
  }
}
.mobile-menu .secondary-wrapper .submenu-header .title {
  font-size: 26px;
  font-size: 1.625rem;
  line-height: 35px;
  line-height: 2.1875rem;
  color: #fff;
}
.mobile-menu .secondary-wrapper .submenu-header .tag {
  font-size: 11px;
  font-size: 0.6875rem;
  line-height: 16px;
  line-height: 1rem;
  letter-spacing: 1px;
  letter-spacing: 0.0625rem;
  border-left: none;
  color: #fff;
  text-transform: uppercase;
}
.mobile-menu .secondary-wrapper .submenu-header .tag .no-value {
  display: none;
}
.mobile-menu .secondary-wrapper jb-secondary-menu-list {
  max-height: 0;
}
.mobile-menu .secondary-wrapper jb-secondary-menu-list.active {
  display: unset;
  max-height: 200vh;
}
.mobile-menu .secondary-wrapper jb-menu-item.span {
  font-size: 21px;
  font-size: 1.3125rem;
}
.mobile-menu .secondary-wrapper jb-menu-item:first-of-type {
  padding-top: 0;
}`;

// src/components/jb-menu/jb-menu.ts
var JbMenu = class extends Initiable(Animatable(h)) {
  constructor() {
    super(...arguments);
    this._isMobileMenu = false;
    this._market = "";
  }
  firstUpdated() {
    this._market = JBCookie.getI18nCookieData().market;
    this._isMobileMenu = isMobile();
    bindEvents(this.renderRoot);
    if (this.active) fadeInPrimaryMenuItems(this.renderRoot, this.renderRoot.querySelector(".primary-wrapper"));
    window.addEventListener(
      "resize",
      debounce(() => {
        this._isMobileMenu = isMobile();
        bindEvents(this.renderRoot);
        this.dispatchEvent(new CustomEvent("jbMenuFullFadeOut"));
        const isSecondaryMenuActive = this.renderRoot.querySelector(".secondary-wrapper.active");
        if (isSecondaryMenuActive) {
          closeSecondaryMenuMobile(this.renderRoot);
        }
      }, 100)
    );
  }
  _getItemMarketTag(item) {
    const matchingSubmenu = this.submenus?.find((sm) => sm.parent === item.submenu);
    const matchingMarketRedirect = matchingSubmenu?.marketRedirects?.find((mr) => mr.marketId === this._market);
    if (!matchingMarketRedirect) {
      return void 0;
    }
    return matchingMarketRedirect.marketName;
  }
  _getSubitems(submenu) {
    if (!submenu.marketRedirects) {
      return submenu.subitems;
    }
    const matchingMarketRedirect = submenu.marketRedirects?.find((mr) => mr.marketId === this._market);
    if (!matchingMarketRedirect) {
      return submenu.subitems;
    }
    return matchingMarketRedirect.subpages.map((sp) => ({ link: { href: sp.url }, text: sp.linktext }));
  }
  _sendTrackingClick(texts, url, e) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e, {
      component_name: "header",
      interaction_effect: url ? "navigation" : "open",
      interaction_element: texts[texts.length - 1],
      interaction_result: url ?? "overlay",
      interaction_text: `hamburger__${texts.join("__")}`,
      interaction_type: "click"
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  _trackMenu(evt) {
    evt.stopPropagation();
    const menuItem = getEventElement(evt, "JB-MENU-ITEM");
    const hasSubmenus = this.submenus?.some((e) => e.parent === menuItem.submenu);
    if (this._isMobileMenu && hasSubmenus) {
      return;
    }
    this._sendTrackingClick([menuItem.text.replace(/\s+/g, "-").toLowerCase()], menuItem.link.href, evt);
  }
  _trackServiceNavigation(evt) {
    const serviceNavigationItem = getEventElement(evt, "JB-SERVICE-NAVIGATION-ITEM");
    const serviceNavigationItemUrl = serviceNavigationItem.link?.data?.action ? void 0 : serviceNavigationItem.link?.href;
    this._sendTrackingClick(
      [serviceNavigationItem.text.replace(/\s+/g, "-").toLowerCase()],
      serviceNavigationItemUrl,
      evt
    );
  }
  _trackSubMenu(evt) {
    evt.stopPropagation();
    const secondaryMenuList = getEventElement(evt, "JB-SECONDARY-MENU-LIST");
    const menuItem = getEventElement(evt, "JB-MENU-ITEM");
    const subMenuItemText = menuItem.text.replace(/\s+/g, "-").toLowerCase();
    const menuItemText = this.items.find((item) => item.submenu === secondaryMenuList.dataset.belongs).text.replace(/\s+/g, "-").toLowerCase();
    this._sendTrackingClick([menuItemText, subMenuItemText], menuItem.link.href, evt);
  }
  render() {
    return ke`<nav
      class="${Rt({
      "mobile-menu": this._isMobileMenu,
      "desktop-menu": !this._isMobileMenu
    })}"
    >
      <div class="wrapper">
        <div class="primary-wrapper">
          <ul
            class="${Rt({
      "initial-animations": this._isMobileMenu,
      primary: true
    })}"
          >
            ${this.items.map(
      (item) => ke`<jb-menu-item
                  .link=${item.link}
                  .submenu=${item.submenu}
                  .tag=${this._getItemMarketTag(item)}
                  .text=${item.text}
                  type="primary"
                  @jb-link:clicked=${this._trackMenu}
                ></jb-menu-item>`
    )}
          </ul>
          ${this.serviceNavigationItems && ke`
            <jb-service-navigation class="${Rt({
      hidden: !this.active
    })}">
              ${this.serviceNavigationItems.map(
      (item) => ke`<jb-service-navigation-item
                    .link="${item.link}"
                    .text="${item.text}"
                    @jb-link:clicked=${this._trackServiceNavigation}
                  ></jb-service-navigation-item>`
    )}</slot>
            </jb-service-navigation>
          `}
        </div>

        ${this.submenus && ke`
          <div class="secondary-wrapper">
            <div
              class="${Rt({
      hidden: !this._isMobileMenu,
      "submenu-header": true
    })}"
            >
              <jb-button-back
                isWhite
                .text=${this.backLabel}
              ></jb-button-back>
              <p class="title"></p>
              <p class="tag"></p>
            </div>

            ${this.submenus.map(
      (submenu) => ke` <jb-secondary-menu-list
                  data-belongs="${submenu.parent}"
                  .market=${this._market}
                  .menuItems=${this._getSubitems(submenu)}
                  .staticItem=${this._isMobileMenu ? submenu.staticItem : D}
                  @jb-link:clicked=${this._trackSubMenu}
                ></jb-secondary-menu-list>`
    )}
          </div>
        `}
      </div>
    </nav>`;
  }
};
JbMenu.styles = r(jb_menu_default);
__decorateClass([
  n({ type: Boolean })
], JbMenu.prototype, "active", 2);
__decorateClass([
  n()
], JbMenu.prototype, "backLabel", 2);
__decorateClass([
  n({ type: Array })
], JbMenu.prototype, "items", 2);
__decorateClass([
  n({ type: Array })
], JbMenu.prototype, "serviceNavigationItems", 2);
__decorateClass([
  n({ type: Array })
], JbMenu.prototype, "submenus", 2);
__decorateClass([
  r2()
], JbMenu.prototype, "_isMobileMenu", 2);
__decorateClass([
  r2()
], JbMenu.prototype, "_market", 2);
JbMenu = __decorateClass([
  customElement("jb-menu")
], JbMenu);

export {
  JbMenu
};
